import { Pipe, PipeTransform } from '@angular/core';
import { HxUiLabelPipe, ProductInfoModel } from 'hx-services';
import { TranslocoService } from '@jsverse/transloco';
import { ADDITIONAL_NOMENCLATURE_CATEGORY_ID } from './product-info-select.constants';

/**
 * Pure pipe used by HxProductInfoSelectComponent when showPrice is true.
 * Returns "Title (450 ₸)" for Доп. номенклатура products that have a price,
 * otherwise returns just the plain title string.
 *
 * Category id 4 ("Доп. номенклатура") matches the constant used across
 * the app (e.g. revenue-by-product.component.ts:306).
 */
@Pipe({
  name: 'productPriceLabel',
  pure: true,
})
export class ProductPriceLabelPipe implements PipeTransform {
  private readonly uiLabel: HxUiLabelPipe;

  constructor(tr: TranslocoService) {
    this.uiLabel = new HxUiLabelPipe(tr);
  }

  transform(
    item: ProductInfoModel,
    priceMap: Map<number, number>,
    showPrice: boolean,
  ): string {
    const title = this.uiLabel.transform(item.title);

    if (
      showPrice &&
      item.categoryId === ADDITIONAL_NOMENCLATURE_CATEGORY_ID &&
      item.id !== undefined &&
      priceMap.has(item.id)
    ) {
      const price = priceMap.get(item.id)!;
      if (price > 0) {
        return `${title} (${price} ₸)`;
      }
    }
    return title;
  }
}
